export default __webpack_public_path__ + "static/media/member-count.e49a5d03.svg";